import { render, staticRenderFns } from "./rendez-vous.html?vue&type=template&id=28a2d54f&scoped=true&external"
import script from "./rendez-vous.js?vue&type=script&lang=js&external"
export * from "./rendez-vous.js?vue&type=script&lang=js&external"
import style0 from "./rendez-vous.scss?vue&type=style&index=0&id=28a2d54f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2d54f",
  null
  
)

export default component.exports